import { UserAvatar } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Личный кабинет: профиль, язык, безопасность, клиники и личное пространство, профиль врача, мои данные. Все роли. */
export const section = defineSection({
  id: 'identity.account',
  area: 'clinic',
  path: 'account',
  roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'DOCTOR', 'FRONT_DESK', 'HR', 'ACCOUNTANT'],
  icon: UserAvatar,
  titleKey: 'account:title',
  namespaces: ['portal'],
  navGroup: 'me',
  order: 900,
  nav: false,
  load: () => import('./AccountPage'),
});

/** Ссылка из уведомления о готовой личной выгрузке (ПОРТ-52): /me/export → «Мои данные». */
export const sections = [
  defineSection({
    id: 'identity.account.export-link',
    area: 'clinic',
    path: 'me/export',
    roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'DOCTOR', 'FRONT_DESK', 'HR', 'ACCOUNTANT'],
    icon: UserAvatar,
    titleKey: 'account:title',
    namespaces: ['portal'],
    order: 901,
    nav: false,
    load: () => import('./DataTabRedirect'),
  }),
];
